import React, { useRef, useState } from 'react';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import Homex from './../Components/Body/Homex';
import {ButtonsCards} from '../Components/ButtonsCards/ButtonsCards';
import NavBar from '../Components/NavBar/NavBar';
import { FallingStars } from './FallingStars';
import Marketing from './Servicios/Marketing';
import DesarrolloWeb from './Servicios/ServicioWeb';
import Sistemas from './Servicios/Sistemas';
import Captacion from './Servicios/Captacion';


const SistemasPage = () => {


  return (
    <div className="App">
     { /*   <FallingStars/>*/}
      <NavBar/>
      <Header />
    
      <Sistemas/>
       <Homex/>  
   { /*  <ButtonsCards/>*/}
   
      <Footer/>
    </div>
   
  );
};

export default SistemasPage;